<div class="search-keywords-page">
    <ng-template #tooltipContent>
        <div>
            <h3 class="text-center">How to use the search</h3>
            <div class="mb-3">Two or more words: "or" statement. For example,
                <em>fast food</em> will search for occurrences of either
                <em>fast</em> or
                <em>food</em>.</div>
            <div class="mb-3">Two or more words, in quotes: search for compound word. For example, searching
                <em>"fast food"</em> will return transcriptions that have the compound word
                <em>fast food</em> (and
                <strong>will not</strong> return transcriptions that have
                <em>food fast</em>, or any variation, with other words between them).</div>
            <div class="mb-3">Word preceded by
                <em>-</em> (without spaces): exclude transcriptions that
                <strong>have</strong> the given word. Will
                <strong>not</strong> work with quotes and compound words.</div>
        </div>
    </ng-template>

    <!-- markets, stations, data time and saved filters section -->
    <div class="row sub-title-row">
        <div class="col-sm-4">
            <div class="sub-title">
                 See and hear what was played!
            </div>
        </div>
        <div class="col-sm-6">
            <div class="row">
                <div class="col-sm-auto p-0">
                    <app-multi-dropbox classForOptions="marketSelected" popupPositionLeft="44" [(ngModel)]="markets" placeholder="Market"
                         noEntriesFoundLabel="No market found" cssClassToApply="dropbox-w-135" #marketMulti 
                        (modelChange)="loadStations(); search()">
                    </app-multi-dropbox>
                </div>
                <div class="col-sm-auto p-0">
                    <app-multi-dropbox classForOptions="stationSelected" popupPositionLeft="44" [(ngModel)]="stations" placeholder="Station" 
                         noEntriesFoundLabel="No station found" #stationMulti [showStationBadge]="true" cssClassToApply="dropbox-w-135"
                        (modelChange)="search()">
                    </app-multi-dropbox>
                </div>
                <div class="col-sm-auto p-0">
                    <app-date-picker [startFormControl]="myForm.controls.startTime" [endFormControl]="myForm.controls.endTime"
                        (modelChange)="search()" #datePicker>
                    </app-date-picker>
                </div>
            </div>
        </div>
        <div class="col-sm-1 float-right">
            <app-multi-dropbox class="float-right"  popupPositionLeft="-61" [(ngModel)]="filterToApply"
                placeholder="Saved Filter" iconClass="material-icons dropbox-search-xl"
                cssClassToApply="dropbox-w-135" [hideFilterButton]="false"
                [allowMultiple]="false" noEntriesFoundLabel="No filter found" #savedFiltersMulti
                (selectionChanged)="applySavedFilter($event)" [enableEdit]="true" (editIconClicked)="editTranscriptFilter($event, false)">
            </app-multi-dropbox>
        </div>
        <div class="col-sm-1">&nbsp;</div>
    </div>
    <div class="row" style="margin: 0px 3px;">
        <div class="col-sm-9 float-left">
            <div class="chip-title"
                [hidden]="!(keywords?.length > 0 || markets?.length > 0 || stations?.length > 0 || myForm.value.startTime || myForm.value.endTime)"
            >Filtered by:
            </div>
            <div class="chip-content"
                [hidden]="!(keywords?.length > 0 || markets?.length > 0 || stations?.length > 0 || myForm.value.startTime || myForm.value.endTime)"
            ><div class="chip-item">
                <mat-chip-list #keywordChipList>
                    <mat-chip color="primary" selected *ngFor="let keyword of keywords" [selectable]="selectable" (removed)="removeKeyword(keyword)">
                        {{keyword.name}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
                <mat-chip-list>
                    <mat-chip color="primary" selected *ngFor="let market of markets" [selectable]="selectable" (removed)="removeMarket(market)">
                        {{ market.name }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
                <mat-chip-list>
                    <mat-chip color="primary" selected *ngFor="let station of stations" [selectable]="selectable" (removed)="removeStation(station)">
                        {{ station.name }}
                        <app-badge-station class="badge-chip" [mergedStation]="station.mergedStation"></app-badge-station>
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
                <mat-chip-list *ngIf="myForm.value.startTime">
                    <mat-chip color="primary" selected [selectable]="selectable" (removed)="removeStartTime()">
                        {{ myForm.value.startTime | date:'MM/dd/yyyy h:mm:ss a'}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
                <mat-chip-list *ngIf="myForm.value.endTime">
                    <mat-chip color="primary" selected [selectable]="selectable" (removed)="removeEndTime()">
                        {{ myForm.value.endTime | date:'MM/dd/yyyy h:mm:ss a'}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
                </div>
            </div>
            <div style="min-width: 176px;"
                [hidden]="!(keywords?.length > 0 || markets?.length > 0 || stations?.length > 0 || myForm.value.startTime || myForm.value.endTime)"
            ><button style="line-height: 24px;" mat-button class="float-right primary-button" (click)="openDialog(false)">SAVE</button>
                <button style="line-height: 24px;" mat-button class="float-right" (click)="clearFilters($event); search()">CLEAR</button>
            </div>
        </div>
        <div class="col-sm-3 float-right">
            <mat-form-field floatLabel="never" class="float-right w-100 search-keywords">
                <input matInput #keywordChipInputBox placeholder="Search for Keywords or Phrases"
                    [matChipInputFor]="keywordChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addKeyword($event)">
                <mat-icon matSuffix class="search-icon">search</mat-icon>
            </mat-form-field>
        </div>
    </div>
    <div class="transcription-list">
        <mat-spinner *ngIf="dataSource.loading$ | async" [diameter]="30" style="margin:0 auto"></mat-spinner>
        <div style="position: absolute; z-index: 999; height: 50px;">
            <app-player-header #appPlayerHeader [hidden]="hidePlayer" style="height: 50px;"></app-player-header>
        </div>
        <table mat-table class="w-100 mat-elevation-z8" [dataSource]="dataSource" matSort matSortActive="date" matSortDirection="desc" matSortDisableClear>
            <ng-container matColumnDef="station">
                <th mat-header-cell class="station-col header-cell" *matHeaderCellDef mat-sort-header>Station</th>
                <td mat-cell class="station-col" *matCellDef="let data">{{data.station}}</td>
            </ng-container>

            <ng-container matColumnDef="transcription">
                <th mat-header-cell class="transcription-col header-cell" *matHeaderCellDef>Transcription</th>
                <td mat-cell class="transcription-col" *matCellDef="let data" [innerHTML]="data.transcription | stylizedText"></td>
            </ng-container>

            <ng-container matColumnDef="source">
                <th mat-header-cell class="source-col header-cell" *matHeaderCellDef>Source</th>
                <td mat-cell class="source-col" *matCellDef="let data" [innerHTML]="data.source | capitalize"></td>
            </ng-container>
            
            <ng-container matColumnDef="keywordAt">
                <th mat-header-cell class="audio-duration-col header-cell" *matHeaderCellDef [hidden]="hideKeywordAt">Keyword at</th>
                <td mat-cell class="audio-duration-col" *matCellDef="let data" [hidden]="hideKeywordAt">{{data.audioPositionSeconds | humanDuration}}</td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell class="date-col header-cell" *matHeaderCellDef mat-sort-header>Date & Time</th>
                <td mat-cell class="date-col" *matCellDef="let data">{{data.startDate | date:'MM/dd/yyyy - h:mm:ss a'}}</td>
            </ng-container>

            <ng-container matColumnDef="icon">
                <th mat-header-cell class="icon-col header-cell" *matHeaderCellDef mat-sort-header>&nbsp;</th>
                <td mat-cell class="icon-col" *matCellDef="let data"><mat-icon color="primary">{{ data.icon }}</mat-icon></td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column -->
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let data" colspan="6">
                    <div class="row" style="margin-top: 5px;">
                        <div class="col-sm-1"></div>
                        <div class="col-sm-10">
                            <p style="font-weight: 900;" [innerHTML]="data.rawTranscription | stylizedText"></p>
                        </div>
                        <div class="col-sm-1"></div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"
                style="background-color: #8c8989;"
            ></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns; let i = index;"
                [style.background]="selectedRowIndex === i ? '#eee' : '' "
                [style.fontWeight]="selectedRowIndex === i ? '900' : '' "
                matRipple
                class="element-row"
                (click)="toggleRow(element, i)"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow"
                [@detailExpand]="row.show ? 'expanded' : 'collapsed'"
                style="overflow: hidden;"
            ></tr>
        </table>
        <mat-card class="no-results" *ngIf="((!(dataSource.loading$ | async)) && (!(dataSource.error$ | async)) && (dataSource.total === 0)) || (dataSource.total == 0)">
            <div>{{noResultMessage}}</div>
        </mat-card>

        <mat-card class="no-results" *ngIf="dataSource.error$ | async">
            <div>The service is temporary unavailable, please try again later.</div>
        </mat-card>

        <mat-paginator [hidden]="dataSource.total === 0" [length]="dataSource.total" [pageSize]="defaultPageSize" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
    </div>
</div>